import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class OtpDialogService {

  constructor(public httpClient: HttpClient) { }

  //verify otp rest
  async verifyOtp(otp: any, grievanceId) {
    const data = {
        otp: otp,
        complaintId: grievanceId
    };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.verifyOtpForGrievance, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //resend otp rest
    async resendOtp(grievanceId) {
      const data = {
        'complaintId': grievanceId
      };
      // const formData = new FormData();
      // formData.append("grievanceRequestDtoString ", JSON.stringify(data));
      // const url = (await grievanceServerUrl) + "resendOTP";
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.resendOTP, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }
    //
}
